import { useImmer } from "use-immer";
import { useEffect } from "react";

const Component = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const pctLow = data.minTpRateLow != null ? Math.round(data.minTpRateLow * 100) : "?";
  const pctMid = data.minTpRateMid != null ? Math.round(data.minTpRateMid * 100) : "?";
  const pctHigh = data.minTpRateHigh != null ? Math.round(data.minTpRateHigh * 100) : "?";
  const tLow = data.fraudThresholdLow ?? "?";
  const tHigh = data.fraudThresholdHigh ?? "?";

  return (
    <article>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Enabled</td>
            <td>
              <input
                type="checkbox"
                checked={!!data.enabled}
                onChange={() =>
                  updateData((d) => {
                    d.enabled = !d.enabled;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Fraud threshold low [count]</td>
            <td>
              <input
                type="number"
                value={data.fraudThresholdLow}
                step={1}
                onChange={(e) =>
                  updateData((d) => {
                    d.fraudThresholdLow = e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Fraud threshold high [count]</td>
            <td>
              <input
                type="number"
                value={data.fraudThresholdHigh}
                step={1}
                onChange={(e) =>
                  updateData((d) => {
                    d.fraudThresholdHigh = e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Min TP rate — low tier [0-1]</td>
            <td>
              <input
                type="number"
                value={data.minTpRateLow}
                step={0.01}
                onChange={(e) =>
                  updateData((d) => {
                    d.minTpRateLow = e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Min TP rate — mid tier [0-1]</td>
            <td>
              <input
                type="number"
                value={data.minTpRateMid}
                step={0.01}
                onChange={(e) =>
                  updateData((d) => {
                    d.minTpRateMid = e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Min TP rate — high tier [0-1]</td>
            <td>
              <input
                type="number"
                value={data.minTpRateHigh}
                step={0.01}
                onChange={(e) =>
                  updateData((d) => {
                    d.minTpRateHigh = e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div className="info-box" style={{ marginTop: "8px" }}>
        <p>
          <strong>Active thresholds:</strong><br />
          {"< "}{tLow} frauds → min TP rate {pctLow}%<br />
          {tLow}–{tHigh} frauds → min TP rate {pctMid}%<br />
          {">"} {tHigh} frauds → min TP rate {pctHigh}%
        </p>
      </div>
    </article>
  );
};

export default Component;
